import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		padding: `${theme.spacing.small} ${theme.spacing.small}`,
		backgroundColor: theme.review.background.color,
		boxShadow: theme.review.elevation,
		borderRadius: theme.borderRadius.rounded,
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
		},
	},
	ratingBox: {
		alignItems: 'start',
		paddingTop: 'unset',

		[getFromBreakpoint('md')]: {
			alignItems: 'center',
		},
	},
	headerLeftSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: theme.spacing.xxsmall,
	},
	headerRightSection: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
	},
	titleContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.micro,
	},
	title: {
		font: theme.review.title.font,
		color: theme.review.heading.color,
	},
	authorAndDate: {
		font: theme.review.info,
		color: theme.review.foreground.color.dimmed,
	},
	body: {
		font: theme.review.body.font,
		color: theme.review.foreground.color.default,
		wordWrap: 'break-word',

		'& p': {
			lineHeight: 'unset',
		},
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'end',
	},
	divider: {
		width: '100%',
		border: theme.divider.border,
	},
	comment: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		paddingLeft: theme.spacing.xsmall,
		borderLeft: theme.review.response.border,
	},
	commentAuthor: {
		font: theme.review.info,
		color: theme.review.foreground.color.dimmed,
	},
}));
